const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div id="home-page">


`);
                this.echo(this.include(context, this.source, this.loadTemplate(`4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 4, 39), new Map([[`class`, `o-container--prose o-container--pad u-pad-block-start-6`]]), false, false, 4));
                this.echo(`

  `);
                this.echo(this.include(context, this.source, this.loadTemplate(`4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 41, 43), new Map([[`class`, `o-container--pad`]]), false, false, 41));
                this.echo(`

  <div class="t-alternate">
    `);
                this.echo(this.include(context, this.source, this.loadTemplate(`4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 76, 48), new Map([[`class`, `o-container--pad`]]), false, false, 76));
                this.echo(`  </div>

  `);
                this.echo(this.include(context, this.source, this.loadTemplate(`4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 145, 53), new Map([[`class`, `o-container--pad`]]), false, false, 145));
                this.echo(`  `);
                this.echo(this.include(context, this.source, `@cloudfour/components/ground-nav/ground-nav.twig`, new Map([[`menu`, new Map([[`items`, new Map([[0, new Map([[`link`, `/does`], [`title`, `What We Do`], [`current`, true]])], [1, new Map([[`link`, `/believes`], [`title`, `Our Approach`]])], [2, new Map([[`link`, `/made`], [`title`, `Our Work`]])], [3, new Map([[`link`, `/thinks`], [`title`, `Articles`]])], [4, new Map([[`link`, `/presents`], [`title`, `Speaking`]])], [5, new Map([[`link`, `/contributes`], [`title`, `Labs`]])], [6, new Map([[`link`, `/is`], [`title`, `Team`]])], [7, new Map([[`link`, `/portland-device-lab`], [`title`, `Device Lab`]])], [8, new Map([[`link`, `https://cloudfour-patterns.netlify.app/`], [`title`, `Patterns`]])], [9, new Map([[`link`, `https://www.responsivefieldday.com/`], [`title`, `Responsive Field Day`]])]])]])], [`social`, new Map([[`items`, new Map([[0, new Map([[`link`, `https://twitter.com/cloudfour`], [`title`, `Follow us on Twitter`], [`icon`, `brands/twitter`]])], [1, new Map([[`link`, `https://github.com/cloudfour`], [`title`, `Find us on GitHub`], [`icon`, `brands/github`]])], [2, new Map([[`link`, `https://www.instagram.com/cloudfourpdx/`], [`title`, `Follow us on Instagram`], [`icon`, `brands/instagram`]])], [3, new Map([[`link`, `https://www.linkedin.com/company/cloud-four`], [`title`, `Follow us on LinkedIn`], [`icon`, `brands/linkedin`]])]])]])], [`action`, new Map([[`lead_in`, `Let’s discuss your project!`], [`title`, `Email us`], [`link`, `mailto:info@cloudfour.com`], [`icon`, `envelope`]])], [`organization`, new Map([[`name`, `Cloud Four, Inc.`], [`address`, new Map([[`street_address`, `510 SW 3rd Ave, Suite 420`], [`address_locality`, `Portland`], [`address_region`, `Oregon`], [`postal_code`, `97204`], [`address_country`, `USA`]])], [`email`, `info@cloudfour.com`], [`telephone`, `+1 (503) 290-1090`], [`url`, `https://cloudfour.com/`], [`founding_date`, `2007-12-13`]])]]), false, false, 194));
                this.echo(`</div>
`);
            }

            getTemplateName() {
                return `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, ``);
            }
        }],
        [39, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/container/container.twig`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 4);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/container/container.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`

    `);
                this.echo(this.include(context, this.source, this.loadTemplate(`4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 10, 38), new Map([[`jaunty`, true], [`generous`, true]]), false, false, 10));
                this.echo(`




  `);
            }

            getTemplateName() {
                return `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, ``);
            }
        }],
        [38, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/media/media.twig`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 10);

                this.blocks = new Map([
                    ['object', [this, 'block_object']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/media/media.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_object(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        <img src="media/home-page/bookicon.png" width="140" height="190" />
      `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        `);
                this.echo(this.include(context, this.source, this.loadTemplate(`4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 15, 37), new Map([[`class`, `o-rhythm--condensed`]]), false, false, 15));
                this.echo(`      `);
            }

            getTemplateName() {
                return `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, ``);
            }
        }],
        [37, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/rhythm/rhythm.twig`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 15);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/rhythm/rhythm.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`            `);
                this.echo(this.include(context, this.source, `@cloudfour/components/heading/heading.twig`, new Map([[`level`, 2], [`content`, `Progressive Web Apps`]]), false, false, 19));
                this.echo(`            <p>Jason Grigsby answers the what, why, and how of PWAs, from making the case in your organization to reaching your users in bold, new ways.</p>
            `);
                this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, new Map([[`content_end_icon`, `arrow-right`], [`label`, `Available Now`]]), false, false, 24));
                this.echo(`          `);
            }

            getTemplateName() {
                return `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, ``);
            }
        }],
        [43, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/container/container.twig`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 41);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/container/container.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`      `);
                this.echo(this.include(context, this.source, this.loadTemplate(`4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 45, 42), undefined, false, false, 45));
                this.echo(`    `);
            }

            getTemplateName() {
                return `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, ``);
            }
        }],
        [42, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/deck/deck.twig`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 45);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/deck/deck.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`          `);
                this.echo(this.include(context, this.source, this.loadTemplate(`4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 47, 40), undefined, false, false, 47));
                this.echo(`          `);
                this.echo(this.include(context, this.source, this.loadTemplate(`4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 58, 41), undefined, false, false, 58));
                this.echo(`        `);
            }

            getTemplateName() {
                return `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, ``);
            }
        }],
        [40, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/card/card.twig`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 47);

                this.blocks = new Map([
                    ['heading', [this, 'block_heading']],
                    ['cover', [this, 'block_cover']],
                    ['content', [this, 'block_content']],
                    ['footer', [this, 'block_footer']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/card/card.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_heading(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`Our goals are audacious.`);
            }

            block_cover(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<img class="cover-image" src="media/home-page/home-goals.svg" alt="">`);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<p>We believe a small company like ours can have an outsized impact on our customers and the world. We bring this perspective to everything we do.</p>`);
            }

            block_footer(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`              `);
                this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, new Map([[`content_end_icon`, `arrow-right`], [`label`, `What Sets Us Apart`]]), false, false, 52));
                this.echo(`            `);
            }

            getTemplateName() {
                return `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, ``);
            }
        }],
        [41, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/card/card.twig`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 58);

                this.blocks = new Map([
                    ['heading', [this, 'block_heading']],
                    ['cover', [this, 'block_cover']],
                    ['content', [this, 'block_content']],
                    ['footer', [this, 'block_footer']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/card/card.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_heading(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`We know the terrain.`);
            }

            block_cover(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<img src="media/home-page/collage-cpe.jpg" alt="">`);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<p>Responsive websites, JavaScript applications, hybrid apps, pattern libraries, you name it… if it’s mobile, we’ve built it.</p>`);
            }

            block_footer(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`            `);
                this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, new Map([[`content_end_icon`, `arrow-right`], [`label`, `Our Work`]]), false, false, 63));
                this.echo(`            `);
            }

            getTemplateName() {
                return `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, ``);
            }
        }],
        [48, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/container/container.twig`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 76);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/container/container.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        `);
                this.echo(this.include(context, this.source, this.loadTemplate(`4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 80, 47), undefined, true, false, 80));
                this.echo(`      `);
            }

            getTemplateName() {
                return `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, ``);
            }
        }],
        [47, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/feature-group/feature-group.twig`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 80);

                this.blocks = new Map([
                    ['intro', [this, 'block_intro']],
                    ['content', [this, 'block_content']],
                    ['action', [this, 'block_action']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/feature-group/feature-group.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_intro(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`            `);
                this.echo(this.include(context, this.source, `@cloudfour/components/heading/heading.twig`, new Map([[`level`, 0], [`weight`, `light`], [`content`, `Featured Articles`]]), false, false, 82));
                this.echo(`
            <p class="u-pad-block-start-1">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
          `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`            `);
                this.echo(this.include(context, this.source, this.loadTemplate(`4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 91, 46), undefined, false, false, 91));
                this.echo(`          `);
            }

            block_action(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`            `);
                this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, new Map([[`class`, `c-button--secondary`], [`content_end_icon`, `arrow-right`], [`label`, `More Articles`]]), false, false, 134));
                this.echo(`          `);
            }

            getTemplateName() {
                return `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, ``);
            }
        }],
        [46, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/deck/deck.twig`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 91);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/deck/deck.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                `);
                this.echo(this.include(context, this.source, this.loadTemplate(`4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 93, 44), new Map([[`href`, `#`]]), false, false, 93));
                this.echo(`
                `);
                this.echo(this.include(context, this.source, this.loadTemplate(`4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 111, 45), new Map([[`href`, `#`]]), false, false, 111));
                this.echo(`
              `);
            }

            getTemplateName() {
                return `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, ``);
            }
        }],
        [44, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/card/card.twig`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 93);

                this.blocks = new Map([
                    ['heading', [this, 'block_heading']],
                    ['cover', [this, 'block_cover']],
                    ['content', [this, 'block_content']],
                    ['footer', [this, 'block_footer']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/card/card.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_heading(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`Faster Integration with Web Components`);
            }

            block_cover(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<img src="media/home-page/speedy-web-components.png" alt="">`);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<p>Web components promise speedier integration. At some level, I understood this. I've even made this…</p>`);
            }

            block_footer(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/author/author.twig`, new Map([[`authors`, new Map([[0, new Map([[`name`, `Jason Grigsby`], [`avatar`, `media/team-avatars/jason.png`], [`link`, `https://cloudfour.com/is/jason`]])]])], [`date`, `2021-05-17T07:00:00.000Z`]]), false, false, 98));
                this.echo(`                  `);
            }

            getTemplateName() {
                return `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, ``);
            }
        }],
        [45, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/card/card.twig`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 111);

                this.blocks = new Map([
                    ['heading', [this, 'block_heading']],
                    ['cover', [this, 'block_cover']],
                    ['content', [this, 'block_content']],
                    ['footer', [this, 'block_footer']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/card/card.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_heading(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`Cooperative Design Systems`);
            }

            block_cover(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<img src="media/home-page/cooperative-plugins.png" alt="">`);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<p>Strategies for when the goals of your project, team or users diverge from those of…</p>
                  `);
            }

            block_footer(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/author/author.twig`, new Map([[`authors`, new Map([[0, new Map([[`name`, `Tyler Sticka`], [`avatar`, `media/team-avatars/tyler.png`], [`link`, `https://cloudfour.com/is/tyler`]])]])], [`date`, `2019-09-09T07:00:00.000Z`]]), false, false, 117));
                this.echo(`                  `);
            }

            getTemplateName() {
                return `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, ``);
            }
        }],
        [53, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/container/container.twig`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 145);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/container/container.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`      `);
                this.echo(this.include(context, this.source, this.loadTemplate(`4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 149, 52), undefined, true, false, 149));
                this.echo(`    `);
            }

            getTemplateName() {
                return `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, ``);
            }
        }],
        [52, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/feature-group/feature-group.twig`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 149);

                this.blocks = new Map([
                    ['intro', [this, 'block_intro']],
                    ['content', [this, 'block_content']],
                    ['action', [this, 'block_action']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/feature-group/feature-group.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_intro(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`          `);
                this.echo(this.include(context, this.source, `@cloudfour/components/heading/heading.twig`, new Map([[`level`, 0], [`weight`, `light`], [`content`, `Upcoming Talks`]]), false, false, 151));
                this.echo(`        `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`          `);
                this.echo(this.include(context, this.source, this.loadTemplate(`4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 158, 51), new Map([[`class`, `o-deck--2-column@m`]]), false, false, 158));
                this.echo(`        `);
            }

            block_action(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`          `);
                this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, new Map([[`class`, `c-button--secondary`], [`content_end_icon`, `arrow-right`], [`label`, `Our Talks`]]), false, false, 185));
                this.echo(`        `);
            }

            getTemplateName() {
                return `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, ``);
            }
        }],
        [51, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/deck/deck.twig`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 158);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/deck/deck.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`
              `);
                this.echo(this.include(context, this.source, this.loadTemplate(`4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 163, 49), new Map([[`datetime`, `2021-10-07`], [`event`, `PWA Summit`], [`location`, `Online`], [`speakers`, new Map([[0, `Jason`], [1, `Gerardo`]])], [`href`, `#`]]), false, false, 163));
                this.echo(`
              `);
                this.echo(this.include(context, this.source, this.loadTemplate(`4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 172, 50), new Map([[`datetime`, `2021-10-13`], [`event`, `An Event Apart Full Summit`], [`location`, `Online`], [`speakers`, new Map([[0, `Jason`]])], [`href`, `#`]]), false, false, 172));
                this.echo(`
            `);
            }

            getTemplateName() {
                return `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, ``);
            }
        }],
        [49, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/event-summary/event-summary.twig`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 163);

                this.blocks = new Map([
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/event-summary/event-summary.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            getTemplateName() {
                return `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, ``);
            }
        }],
        [50, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/event-summary/event-summary.twig`, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, 172);

                this.blocks = new Map([
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/event-summary/event-summary.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            getTemplateName() {
                return `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7');

let template = env.loadTemplate('4f681b83c2d187bba38df5ad28d294a9d44f9560d3ef435cdb9d2ce1fe67a6b7');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/prototypes/home-page/example/example.twig", args: context }
     );
     return rendered;;
};